import React from "react";
import DataGridTableAdapter from "./DataGridTableAdapter";

class LeaderBoardRMCompact extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }

  refreshTable() {
    fetch(process.env.REACT_APP_BACKEND_HOST + `/api/getPlayerModes`)
      .then((response) => response.json())
      .then((players) =>
        this.setState({
          data: players.sort(function (a, b) { return parseInt((b.rating_rm_1vs1 + (b.rating_rm_2vs2 + b.rating_rm_3vs3 + b.rating_rm_4vs4) / 3) / 2) - parseInt((a.rating_rm_1vs1 + (a.rating_rm_2vs2 + a.rating_rm_3vs3 + a.rating_rm_4vs4) / 3) / 2) }),
        })
      ).catch(rejected => {
        console.log(rejected);
      });
  }

  componentDidMount() {
    this.refreshTable();
  }

  columns = [
    {
      field: 'discord_avatar',
      title: ' ',
      sorting: false,
      grouping: false,
      align: "right",
      render: rowData =>
        rowData.discord_avatar ?
          <img src={`https://cdn.discordapp.com/avatars/${rowData.discord_id}/${rowData.discord_avatar}.webp?size=1024`}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = "https://cdn.discordapp.com/embed/avatars/1.png?size=1024";
            }
            }
            alt="avatar"
            style={{ width: 25, borderRadius: '50%' }}
          /> :
          <img src={`https://cdn.discordapp.com/embed/avatars/0.png?size=1024`}
            alt="avatar"
            style={{ width: 25, borderRadius: '50%' }}
          />
    },
    {
      title: "Utente Discord", field: "discord_name", type: "numeric", align: "left",
      render: rowData => <a
        href={`discord://discordapp.com/users/${rowData.discord_id}/`}
        target="_blank"
        rel="noreferrer"
      >
        {rowData.discord_name}
      </a>
    },
    {
      title: "Utente AoE", field: "name",
      render: rowData => <a
        href={`http://aoe4world.com/players/${rowData.profile_id}`}
        target="_blank"
        rel="noreferrer"
      >
        {rowData.name}
      </a>
    },
    {
      title: "Elo (Partite) RM 1vs1", field: "rating_rm_1vs1",
      render: rowData => <div>{rowData.rating_rm_1vs1}
        <small> ({rowData.games_rm_1vs1})</small>
      </div>
    },
    {
      title: "Elo (Partite) RM 2vs2", field: "rating_rm_2vs2",
      render: rowData => <div>{rowData.rating_rm_2vs2}
        <small> ({rowData.games_rm_2vs2})</small>
      </div>
    },
    {

      title: "Elo (Partite) RM 3vs3", field: "rating_rm_3vs3",
      render: rowData => <div>{rowData.rating_rm_3vs3}
        <small> ({rowData.games_rm_3vs3})</small>
      </div>
    },
    {
      title: "Elo (Partite) RM 4vs4", field: "rating_rm_4vs4",
      render: rowData => <div>{rowData.rating_rm_4vs4}
        <small> ({rowData.games_rm_4vs4})</small>
      </div>
    },
    {
      title: "Elo Medio Solo-Tg", field: "elo",
      sorting: false,
      render: rowData => {
        var elo_solo = Math.round(rowData.rating_rm_1vs1);
        var elo_tg = Math.round((rowData.rating_rm_2vs2 + rowData.rating_rm_3vs3 + rowData.rating_rm_4vs4) / 3);
        var elo = Math.round((elo_solo + elo_tg) / 2)
        if ((rowData.rating_rm_1vs1 === 0 || rowData.rating_rm_2vs2 === 0 || rowData.rating_rm_3vs3 === 0 || rowData.rating_rm_4vs4 === 0)) {
          return <div>?</div>;
        } else return <div>{elo}</div>;
        ;
      },
    },
    {
      title: "Scudi Singolo", field: "scudi_solo",
      sorting: false,
      render: rowData => {
        var scudi_solo = Math.round((((rowData.rating_rm_1vs1)) - 800) / 10);
        if ((rowData.rating_rm_1vs1 === 0)) {
          return <div>?</div>;
        } else return <div>{scudi_solo}</div>;
        ;
      },
    },
    {
      title: "Scudi Team", field: "scudi_tg",
      sorting: false,
      render: rowData => {
        var scudi_tg = Math.round((((rowData.rating_rm_2vs2 + rowData.rating_rm_3vs3 + rowData.rating_rm_4vs4) / 3) - 800) / 10);
        if ((rowData.rating_rm_2vs2 === 0 || rowData.rating_rm_3vs3 === 0 || rowData.rating_rm_4vs4 === 0)) {
          return <div>?</div>;
        } else return <div>{scudi_tg}</div>;
        ;
      },
    },
    {
      title: "Scudi Totali", field: "scudi",
      sorting: false,
      render: rowData => {
        var highest_lowest_diff = 800
        var scudi_solo = Math.round((((rowData.rating_rm_1vs1)) - highest_lowest_diff) / 10);
        var scudi_tg = Math.round((((rowData.rating_rm_2vs2 + rowData.rating_rm_3vs3 + rowData.rating_rm_4vs4) / 3) - highest_lowest_diff) / 10);
        var scudi = Math.round((scudi_solo + scudi_tg) / 2)
        if ((rowData.rating_rm_1vs1 === 0 || rowData.rating_rm_2vs2 === 0 || rowData.rating_rm_3vs3 === 0 || rowData.rating_rm_4vs4 === 0)) {
          return <div>?</div>;
        } else return <div>{scudi}</div>;
        ;
      },
    },
  ];


  render() {
    return (
      <div className="LeaderBoard">
        <DataGridTableAdapter
          columns={this.columns}
          data={this.state.data}
          title=""
          onRefresh={() => this.refreshTable()}
        />
      </div>
    );
  }
}

export default LeaderBoardRMCompact;

